import React, { useMemo } from 'react';
import type { IronAppProps } from '@app/shell/types/app';

const combineNamespaces = (incoming, original) => {
  if (Object.keys(incoming)?.length === 0 || incoming?.ns?.length === 0) {
    return original;
  }

  // this should always be the case
  if (original?.ns?.length) {
    incoming?.ns?.unshift(...original.ns);

    // copy common namespaces loaded intially into new store
    for (const namespace of original.ns) {
      incoming.initialI18nStore[original.initialLocale][namespace] =
        original.initialI18nStore[original.initialLocale][namespace];
    }
  }

  return incoming;
};

const withSavedProps = (Component) => {
  const wrappedComponent = ({ pageProps, ...restOfProps }: IronAppProps) => {
    const isInitialLoad = !!pageProps?.req;
    const initialI18NTranslations = useMemo(() => pageProps?._nextI18Next, []);
    const initialRequestProps = useMemo(() => pageProps?.req, []);

    pageProps.req = pageProps.req || initialRequestProps;

    // we only provide the common namespaces to the initial load, page transitions will only load new namespaces.
    // which means we need to append the common namespaces to the new store.
    // or if no page specific namespaces are loaded, just use the default store.
    pageProps._nextI18Next = isInitialLoad
      ? initialI18NTranslations
      : combineNamespaces(
          pageProps._nextI18Next ?? {},
          initialI18NTranslations,
        );

    return <Component pageProps={pageProps} {...restOfProps} />;
  };

  return wrappedComponent;
};

export default withSavedProps;
